import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ReportsModel } from '../model/index';

@Injectable()
export class ReportsService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private reportUrl = 'api/reports';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getReports(query: any): Promise<ReportsModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getReports`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteSrfHistory(ser_id: any): Promise<any> {
        const url = `${this.reportUrl}/deleteSrfHistory`;
        return this.http
            .post(url, $.param({ ser_id: ser_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    // START - CR-20
    getServiceWalkInImageList(query: any): Promise<ReportsModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getServiceWalkInImageList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteServiceWalkInImage(query: any): Promise<ReportsModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/deleteServiceWalkInImage`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    // END CR-20


    getClientPointsHistory(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getClientPointsHistory`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getRecheckupReport(params: any): Promise<any> {
        const url = `${this.reportUrl}/recheckupReport`;
        return this.http
            .post(url, $.param(params), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getNotificationUserList(): Promise<any> {
        const url = `${this.reportUrl}/getNotificationUserList`;
        return this.http.get(url, { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getClientHistoryReport(params: any): Promise<any> {
        let urlParams: URLSearchParams = new URLSearchParams();
        for (let key in params) {
            urlParams.set(key.toString(), params[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: urlParams
        });

        const url = `${this.reportUrl}/getClientHistoryReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getReferralReport(params: any): Promise<any> {
        let urlParams: URLSearchParams = new URLSearchParams();
        for (let key in params) {
            urlParams.set(key.toString(), params[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: urlParams
        });

        const url = `${this.reportUrl}/getReferralReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getCampPromoReport(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getCampPromoReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/reports.service.ts